/**
 * Centralized brand config — single source of truth for Luvia jewelry store.
 * Use BRAND.name, BRAND.url, BRAND.tagline across frontend, metadata, and schema.
 */
export const BRAND = {
  name: 'Luvia',
  handle: '@theluviajewels',
  tagline: 'Elegant artificial jewelry for every occasion',
  instagram: 'https://www.instagram.com/theluviajewels',
  url: 'https://theluviajewels.com',
  /** Support and privacy contact emails. */
  email: 'support@theluviajewels.com',
  /** Currency code for meta, structured data, analytics (e.g. INR, USD). */
  currency: 'INR',
  /** Locale for og:locale and Intl (e.g. en, en_IN). Use neutral 'en' for global. */
  locale: 'en',
  /** Product image placeholder when no image is available (jewelry-appropriate). */
  placeholderProduct: '/placeholder-jewelry.svg',
};
